import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import OverlayTrigger from 'components/overlay_trigger';
import PostContext from 'components/post_view/post_context';
import Tooltip from 'components/tooltip';
import FlagIcon from 'components/widgets/icons/flag_icon';
import FlagIconFilled from 'components/widgets/icons/flag_icon_filled';
import Constants, {A11yCustomEventTypes} from 'utils/constants';
import {localizeMessage} from 'utils/utils';

export default class PostFlagIcon extends React.PureComponent {
    static contextType = PostContext;
    static get propTypes() {
        return {
            postId: PropTypes.string.isRequired,
            isFlagged: PropTypes.bool.isRequired,
            actions: PropTypes.shape({
                flagPost: PropTypes.func.isRequired,
                unflagPost: PropTypes.func.isRequired,
            }).isRequired,
            onPostFlagToggled: PropTypes.func,
        };
    }

    constructor() {
        super();

        this.buttonRef = React.createRef();

        this.state = {
            a11yActive: false,
        };
    }

    componentDidMount() {
        if (this.buttonRef.current) {
            this.buttonRef.current.addEventListener(A11yCustomEventTypes.ACTIVATE, this.handleA11yActivateEvent);
            this.buttonRef.current.addEventListener(A11yCustomEventTypes.DEACTIVATE, this.handleA11yDeactivateEvent);
        }
    }
    componentWillUnmount() {
        if (this.buttonRef.current) {
            this.buttonRef.current.removeEventListener(A11yCustomEventTypes.ACTIVATE, this.handleA11yActivateEvent);
            this.buttonRef.current.removeEventListener(A11yCustomEventTypes.DEACTIVATE, this.handleA11yDeactivateEvent);
        }
    }

    componentDidUpdate() {
        if (this.state.a11yActive && this.buttonRef.current) {
            this.buttonRef.current.dispatchEvent(new Event(A11yCustomEventTypes.UPDATE));
        }
    }

    handlePress = (e) => {
        e.preventDefault();

        const {
            actions,
            isFlagged,
            postId,
        } = this.props;

        if (isFlagged) {
            actions.unflagPost(postId);
        } else {
            actions.flagPost(postId);
        }

        this.context.onLogPostAction(isFlagged ? 'unsave' : 'save', 'popup');
        this.props.onPostFlagToggled?.(!isFlagged);
    }

    handleA11yActivateEvent = () => {
        this.setState({a11yActive: true});
    }

    handleA11yDeactivateEvent = () => {
        this.setState({a11yActive: false});
    }

    render() {
        const isFlagged = this.props.isFlagged;

        let flagIcon;
        if (isFlagged) {
            flagIcon = <FlagIconFilled className={classNames('icon', 'icon--small', 'icon--small-filled', {'post-menu__item--selected': isFlagged})}/>;
        } else {
            flagIcon = <FlagIcon className={classNames('icon', 'icon--small')}/>;
        }

        return (
            <OverlayTrigger
                className='hidden-xs'
                key={`flagtooltipkey${isFlagged ? 'flagged' : ''}`}
                delayShow={Constants.OVERLAY_TIME_DELAY}
                placement='top'
                overlay={
                    <Tooltip
                        id='flagTooltip'
                        className='hidden-xs'
                    >
                        <FormattedMessage
                            id={isFlagged ? 'flag_post.unflag' : 'flag_post.flag'}
                            defaultMessage={isFlagged ? 'Remove from Saved' : 'Save'}
                        />
                    </Tooltip>
                }
            >
                <button
                    ref={this.buttonRef}
                    id={`${this.context.location}_flagIcon_${this.props.postId}`}
                    aria-label={isFlagged ? localizeMessage('flag_post.unflag', 'Remove from Saved').toLowerCase() : localizeMessage('flag_post.flag', 'Save').toLowerCase()}
                    className='post-menu__item'
                    onClick={this.handlePress}
                    data-qa='button_save_post'
                >
                    {flagIcon}
                </button>
            </OverlayTrigger>
        );
    }
}
